import { render, staticRenderFns } from "./QRCodeScanner.vue?vue&type=template&id=079bdf3a&scoped=true&"
import script from "./QRCodeScanner.vue?vue&type=script&lang=js&"
export * from "./QRCodeScanner.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeScanner.vue?vue&type=style&index=0&id=079bdf3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079bdf3a",
  null
  
)

component.options.__file = "QRCodeScanner.vue"
export default component.exports